export default "__VITE_ASSET__DF84qlWF__"